import { configureStore } from '@reduxjs/toolkit';
import languageSlice from './language/languageSlice';

export const store = configureStore({
  reducer: {
    language: languageSlice,
  },
});